export default "./icons/Pattern.jpg";